<template>
  <nav id="nav" :class="{ 'nav-scrolled': isScrolled }">
    <div class="nav-container">
      <router-link to="/" class="nav-brand" aria-label="Stardust Network Home">
        <img src="../assets/logo.png" alt="Stardust logo">
        <span class="brand-text">Stardust Network</span>
      </router-link>

      <button
        class="hamburger"
        :class="{ 'is-active': isMenuOpen }"
        @click="toggleMenu"
        :aria-expanded="isMenuOpen.toString()"
        aria-controls="nav-menu"
        aria-label="Toggle navigation menu"
      >
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </button>

      <div id="nav-menu" class="nav-menu" :class="{ 'is-active': isMenuOpen }">
        <router-link to="/" class="nav-link" @click="closeMenu">Home</router-link>
        <router-link to="/about" class="nav-link" @click="closeMenu">About</router-link>
        <router-link to="/contribute" class="nav-link" @click="closeMenu">Contribute</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavbarSection",
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 10;
    },
  },
};
</script>

<style scoped>
#nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  text-align: center;
  padding: 1.2em 2em;
  background-color: var(--color-charcoal-mist-85);
  backdrop-filter: var(--blur-navbar);
  filter: var(--shadow-card);
  transition: var(--transition-standard);
}

#nav.nav-scrolled {
  background-color: var(--color-charcoal-mist-95);
  padding: 0.8em 2em;
}

.nav-container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: var(--spacing-sm);
  transition: var(--transition-quick);
}

.nav-brand:hover {
  transform: scale(1.05);
}

.nav-brand img {
  -webkit-filter: var(--shadow-brand);
  filter: var(--shadow-brand);
  transition: var(--transition-quick);
  height: 50px;
}

#nav.nav-scrolled .nav-brand img {
  height: 40px;
}

.brand-text {
  color: var(--color-stardust-gold);
  font-family: Raleway;
  font-weight: var(--font-weight-semibold);
  font-size: clamp(20px, 4vw, 28px);
  -webkit-filter: var(--shadow-brand);
  filter: var(--shadow-brand);
  transition: var(--transition-standard);
}

#nav.nav-scrolled .brand-text {
  font-size: clamp(18px, 3.5vw, 24px);
}

.nav-menu {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.nav-link {
  color: var(--color-pure-white);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  font-size: 16px;
  transition: var(--transition-standard);
  position: relative;
  padding: 0.5rem 0;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: var(--color-stardust-gold);
  transition: var(--transition-standard);
}

.nav-link:hover {
  color: var(--color-stardust-gold);
  transform: translateY(-2px);
}

.nav-link:hover::after,
.nav-link.router-link-exact-active::after,
.nav-link.router-link-active::after {
  width: 100%;
}

.nav-link.router-link-exact-active,
.nav-link.router-link-active {
  color: var(--color-stardust-gold);
}

.nav-link:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 4px;
  border-radius: 4px;
}

.hamburger {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1001;
  gap: 5px;
}

.hamburger:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 4px;
  border-radius: 4px;
}

.hamburger-line {
  width: 25px;
  height: 3px;
  background-color: var(--color-pure-white);
  transition: var(--transition-standard);
  border-radius: 2px;
}

@media (max-width: 768px) {
  #nav {
    padding: 0.8em 1em;
  }

  .hamburger {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    top: 0;
    right: -100%;
    height: 100vh;
    width: 70%;
    max-width: 300px;
    background-color: rgba(40, 54, 60, 0.98);
    backdrop-filter: var(--blur-navbar);
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    transition: right 0.3s ease;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  }

  .nav-menu.is-active {
    right: 0;
  }

  .nav-link {
    font-size: 20px;
    padding: 1rem;
  }

  .brand-text {
    font-size: 20px !important;
  }

  .nav-brand img {
    height: 40px !important;
  }

  .hamburger.is-active .hamburger-line:nth-child(1) {
    transform: rotate(45deg) translate(8px, 8px);
  }

  .hamburger.is-active .hamburger-line:nth-child(2) {
    opacity: 0;
  }

  .hamburger.is-active .hamburger-line:nth-child(3) {
    transform: rotate(-45deg) translate(8px, -8px);
  }
}

@media (max-width: 500px) {
  .brand-text {
    font-size: 18px !important;
  }

  .nav-brand img {
    height: 35px !important;
  }
}
</style>
